<!--
 * @Descripttion: 
 * @version: 
 * @Author: renqiang_hu
 * @Date: 2021-05-11 09:28:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-17 17:05:26
 * @FilePath: \heshan_web\src\views\overView\alarmPush.vue
-->
<template>

</template>
<script>
import { sendSock,initWebSocket,websocketclose } from '@/util/socket.js';
export default {
    data(){
        return{
            
        }
    },
    mounted(){
        //   this.getsocket()
        console.log(123456)
    },
    methods:{
        getsocket(){
            
            initWebSocket(`ws://192.168.1.103:5010/ws`, 0);
            sendSock('',0,(res)=>{
                    console.log(res)
                    
            })
        },
    }
}
</script>